import { render, staticRenderFns } from "./P04FourDigit.vue?vue&type=template&id=1a23c58a&scoped=true"
import script from "./P04FourDigit.vue?vue&type=script&lang=js"
export * from "./P04FourDigit.vue?vue&type=script&lang=js"
import style0 from "./P04FourDigit.vue?vue&type=style&index=0&id=1a23c58a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a23c58a",
  null
  
)

export default component.exports